import React, { useState, useEffect } from 'react';
import configurationService from 'services/f5-services/configurationService';
import PageContainer from '../../../../@jumbo/components/PageComponents/layouts/PageContainer';

import sweetAlert from 'f5/utils/sweetAlert';

import OcurrenceNavbar from '../../../../f5/ocurrences/SharedComponents/OcurrenceNavbar';
import ConfigTablePage from 'f5/configuration/ConfigTablePage';
import NewOrUpdate from '../shared/NewOrUpdate';
import SharedActions from 'f5/configuration/SharedActions';

import SectorCustomForm from './SectorCustomForm';

const Sector = () => {
  const [loading, setLoading] = useState(false);
  const [sectors, setSectors] = useState([]);
  const [newOrUpdate, setNewOrUpdate] = useState({
    mode: 'none',
    id: '',
    name: '',
  });

  const validator = () => {
    if (newOrUpdate.name) {
      return { nome: newOrUpdate.name, id: newOrUpdate.id };
    }

    return false;
  };

  useEffect(() => {
    setLoading(true);
    const getData = async () => {
      const results = await configurationService.getConfigParameter('setor');
      setSectors(results.items.map(item => ({ name: item.nome, id: item.id })));
      setLoading(false);
    };
    getData();
  }, [setLoading, setSectors]);

  const resetNewOrUpdate = () => {
    setNewOrUpdate({ mode: 'none' });
  };

  const handleDelete = async id => {
    setLoading(true);
    const deleteResult = await configurationService.deleteConfigParameter(id, 'setor');
    const results = await configurationService.getConfigParameter('setor');
    setSectors(results.items.map(item => ({ name: item.nome, id: item.id })));
    setLoading(false);
    if (deleteResult.success) {
      sweetAlert('success', 'Sucesso', 'Setor foi deletada com sucesso!', () => {
        resetNewOrUpdate();
      });
    } else {
      sweetAlert('error', 'Falha', 'Não foi possível deletar setor!', () => {
        resetNewOrUpdate();
      });
    }
  };

  const handleCreate = async data => {
    setLoading(true);
    const addResult = await configurationService.addConfigParameter('setor', data);
    const results = await configurationService.getConfigParameter('setor');
    setSectors(results.items.map(item => ({ name: item.nome, id: item.id })));
    setLoading(false);
    if (addResult.success) {
      sweetAlert('success', 'Sucesso', 'Setor foi adicionada com sucesso!', () => {
        resetNewOrUpdate();
      });
    } else {
      sweetAlert('error', 'Falha', 'Não foi possível adicionar setor!', () => {
        resetNewOrUpdate();
      });
    }
  };

  const handleEdit = async data => {
    setLoading(true);
    const addResult = await configurationService.editConfigParameter('setor', data);
    const results = await configurationService.getConfigParameter('setor');
    setSectors(results.items.map(item => ({ name: item.nome, id: item.id })));
    setLoading(false);
    if (addResult.success) {
      sweetAlert('success', 'Sucesso', 'Setor foi editada com sucesso!', () => {
        resetNewOrUpdate();
      });
    } else {
      sweetAlert('error', 'Falha', 'Não foi possível editar setor!', () => {
        resetNewOrUpdate();
      });
    }
  };

  const columns = [
    {
      title: 'Nome',
      field: 'name',
    },
    {
      title: 'Ações',
      field: 'actions',
      width: '20%',
      render: rowData => (
        <SharedActions
          editCallback={() => setNewOrUpdate({ mode: 'edit', name: rowData.name, id: rowData.id })}
          deleteCallback={() => handleDelete(rowData.id)}
        />
      ),
    },
  ];

  return (
    <PageContainer>
      <OcurrenceNavbar />
      {newOrUpdate.mode !== 'none' ? (
        <NewOrUpdate
          newOrUpdate={newOrUpdate}
          setNewOrUpdate={setNewOrUpdate}
          handleCreate={handleCreate}
          handleEdit={handleEdit}
          loading={loading}
          validator={validator}
          addTitle="Adicionar novo setor"
          editTitle="Editar setor">
          <SectorCustomForm newOrUpdate={newOrUpdate} setNewOrUpdate={setNewOrUpdate} />
        </NewOrUpdate>
      ) : (
        <ConfigTablePage
          loading={loading}
          data={sectors}
          columns={columns}
          title={'Setores'}
          newCallback={() => setNewOrUpdate({ mode: 'add' })}
        />
      )}
    </PageContainer>
  );
};

export default Sector;
